import React from "react";
import { NavigationHelper } from "../helpers";

export const ScreensPage: React.FC = () => {
  React.useEffect(() => { setTimeout(NavigationHelper.showMobileSidebar, 10) }, []) // eslint-disable-line

  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="fas fa-tv"></i> Screens</h1>
        <p className="page-subtitle">Manage your digital signage displays</p>
      </div>
      <p>Select a screen on the left or create a new one.</p>
    </div>
  );
};